/** Super-admin Mistral config + usage service — /api/v1/admin/{settings,analytics}/mistral */
import api from '../shared/services/api';

export interface MistralSettings {
  configured: boolean;
  masked_key: string | null;
  source: 'admin' | 'env' | 'none';
  model: string;
  updated_at: string | null;
  last_tested: string | null;
  last_test_ok: boolean | null;
}

export interface MistralUsage {
  days: number;
  total_requests: number;
  total_tokens: number;
  est_cost: number;
  series: { date: string; requests: number; tokens: number; est_cost: number }[];
  by_model: { model: string; requests: number; tokens: number; est_cost: number }[];
}

export async function getMistralSettings(): Promise<MistralSettings> {
  const r = await api.get<MistralSettings>('/api/v1/admin/settings/mistral');
  return r.data;
}

export async function setMistralKey(apiKey: string): Promise<MistralSettings> {
  const r = await api.post('/api/v1/admin/settings/mistral', { api_key: apiKey });
  return r.data;
}

export async function testMistral(): Promise<{ ok: boolean; latency_ms: number; error: string | null }> {
  const r = await api.post('/api/v1/admin/settings/mistral/test');
  return r.data;
}

export async function getMistralUsage(days = 30): Promise<MistralUsage> {
  const r = await api.get<MistralUsage>('/api/v1/admin/analytics/mistral', { params: { days } });
  return r.data;
}
